import { tv } from "tailwind-variants";

export const languageSelector = tv({
    base: ["tw:focus:bg-transparent tw:hover:bg-transparent tw:px-0"],
    variants: {
        layout: {
            default: [
                "tw:transition-none",
                "tw:bg-transparent tw:border-none tw:shadow-none",
                "tw:focus:bg-transparent!tw:focus:border-none! tw:focus:ring-0!",
                "tw:hover:bg-transparent! tw:hover:border-none! tw:hover:ring-0!",
                "tw:active:bg-transparent! tw:active:border-none! tw:active:ring-0!"
            ],
            toggle: "tw:no-underline tw:hover:cursor-pointer"
        },
        color: {
            black: "tw:text-black",
            primary: "tw:text-primary",
            secondary: "tw:text-secondary",
            tertiary: "tw:text-tertiary",
            information: "tw:text-information",
            success: "tw:text-success",
            warning: "tw:text-warning",
            danger: "tw:text-danger",
            white: "tw:text-white",
            yellow: "tw:text-yellow",
            darkGrey: "tw:text-grey-dark",
            grey: "tw:text-grey",
            lightGrey: "tw:text-grey-light",
            transparent: "tw:text-black"
        }
    },
    compoundVariants: [
        {
            layout: "default",
            color: "black",
            class: "tw:text-black tw:focus:text-black tw:hover:text-black tw:active:text-black"
        },
        {
            layout: "default",
            color: "white",
            class: "tw:text-white tw:focus:text-white tw:hover:text-white tw:active:text-white"
        },
        {
            layout: "default",
            color: "primary",
            class: "tw:text-primary tw:focus:text-primary tw:hover:text-primary tw:active:text-primary"
        },
        {
            layout: "default",
            color: "secondary",
            class: "tw:text-secondary tw:focus:text-secondary tw:hover:text-secondary tw:active:text-secondary"
        },
        {
            layout: "default",
            color: "tertiary",
            class: "tw:text-tertiary tw:focus:text-tertiary tw:hover:text-tertiary tw:active:text-tertiary"
        },
        {
            layout: "default",
            color: "information",
            class: "tw:text-information tw:focus:text-information tw:hover:text-information tw:active:text-information"
        },
        {
            layout: "default",
            color: "success",
            class: "tw:text-success tw:focus:text-success tw:hover:text-success tw:active:text-success"
        },
        {
            layout: "default",
            color: "warning",
            class: "tw:text-warning tw:focus:text-warning tw:hover:text-warning tw:active:text-warning"
        },
        {
            layout: "default",
            color: "danger",
            class: "tw:text-danger tw:focus:text-danger tw:hover:text-danger tw:active:text-danger"
        },
        {
            layout: "default",
            color: "yellow",
            class: "tw:text-yellow tw:focus:text-yellow tw:hover:text-yellow tw:active:text-yellow"
        },
        {
            layout: "default",
            color: "darkGrey",
            class: "tw:text-grey-dark tw:focus:text-dark tw:hover:text-dark tw:active:text-dark"
        },
        {
            layout: "default",
            color: "grey",
            class: "tw:text-grey tw:focus:text-grey tw:hover:text-grey tw:active:text-grey"
        },
        {
            layout: "default",
            color: "lightGrey",
            class: "tw:text-grey-light tw:focus:text-grey-light tw:hover:text-grey-light tw:active:text-grey-light"
        },
        {
            layout: "default",
            color: "transparent",
            class: "tw:focus:bg-transparent tw:hover:bg-transparent"
        }
    ],
    defaultVariants: {
        layout: "default",
        color: "black"
    }
});
